import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./fonts/fonts.css";

// var originalWarning = console.warn; // back up the original method
console.warn = function () {};

ReactDOM.render(<App />, document.getElementById("root"));
